export const menuItems = [
  {
    icon: "file-circle-check",
    title: "Propostas",
    description:
      "Cadastre e gerencie propostas de crédito e programas de fidelidade de forma simplificada."
  }
  /*
  {
    icon: "dollar-sign",
    title: "Vendas",
    description:
      "Nesse módulo é feito a compra, o pagamento e a pontuação do programa fidelidade de forma integrada e segura.",
  },
  {
    icon: "chart-line",
    title: "Relatórios",
    description:
      "Tenha acesso online a relatórios detalhados e informações essenciais para acompanhar a performance do seu negócio.",
  },
  {
    icon: "shield-keyhole",
    title: "Segurança",
    description:
      "Garanta a segurança e a confiabilidade das suas operações financeiras, além do controle de acesso às funcionalidades através de permissões.",
  },
  {
    icon: "headset",
    title: "Suporte",
    description:
      "Conte com uma equipe de suporte dedicada para ajudar você a resolver qualquer dúvida ou problema.",
  },
  */
];
